<div class="vibration-wrapper">

  <div class="modal-header">
    <h4 class="modal-title pull-left">{{'GLOBAL.VIBRATIONS' | translate}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-box">
      <form #f="ngForm" id="vibrationForm" (ngSubmit)="onSubmit($any(f))" class="form">
        <div class="row">
          <div class="col-md-6 form-group">
            <label for="selectPtControl">{{'CONTROL_POINT.CONTROL_POINT'| translate}}</label>
            <ng-select name="selectPtControl"
              id="selectPtControl"
              [items]="controlPoints"
              #selectPtControl="ngModel"
              bindLabel="name"
              [(ngModel)]="activeControlPoint"
              [ngClass]="{'art':!selectPtControl.valid && f.submitted}"
              required>
            </ng-select>
          </div>
          <div class="col-md-6 form-group">
            <label for="distance">{{'VIBRATION.DISTANCE' | translate}} </label>
            <input type="number" id="distance" name="distance" class="form-control" [(ngModel)]="vibrationView.distance " />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 form-group">
            <label for="ppv">{{'VIBRATION.PIC' | translate}}</label>
            <input type="number" id="ppv" name="ppv" class="form-control" #ppv="ngModel" [(ngModel)]="vibrationView.picVibration" />
          </div>
          <div class="col-md-6 form-group">
            <label for="pressure">{{'VIBRATION.SURPRESSION' | translate}}</label>
            <input type="number" id="pressure" name="pressure" class="form-control" [(ngModel)]="vibrationView.surpression " />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 form-group controls-btn">
            <!-- btn valider -->
            <button type="submit" form="vibrationForm"
              class="btn btn-outline-success btn-hover" style="margin-right:10px;">
              {{'GLOBAL.VALIDER' | translate}}
            </button>

            @if (!estModif()) {
              <label class="toggle">
                <input type="checkbox" [checked]="isRemoteOrLocal()" (change)="changeRemoteOrLocal($any($event))">
                <span class="slider"></span>
                <span class="labels" data-on="Local" data-off="Remote"></span>
              </label>
            }

            <!-- btn delete -->
            @if (estModif() && vibrationsNewModelSelected()) {
              <button type="button" class="btn btn-danger" (click)="deleteFromTir()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
            }
            @if (estModif() && !vibrationsNewModelSelected()) {
              <button type="button" class="btn btn-danger" (click)="deleteOldVibrationFromTir()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
            }


          </div>
          <div class="col-md-6 form-group">
            @if (!selectPtControl.valid && f.submitted) {
              <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
            }

          </div>
        </div>

          @if (erreurApi()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
        }
      </form>

      <!-- drag & drop zone -->
      <div class="drag-chart-box">

        <label style="margin-bottom:0; font-size:1.15rem;" >Drag&Drop File (.sis, .csv) </label>
        <ngx-file-drop [multiple]="true" class="drag-drop"  dropZoneLabel="Drop files here" (onFileDrop)="dropped($any($event))"
          >
          <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <button class="btn-drag-click" type="button" (click)="openFileSelector()">Upload files <i class="fas fa-upload"></i></button>
            <div class="overflow-box" [ngClass]="{'overflow-auto': isMoreThanFour}">
              <div class="drag-chart" [ngClass]="{'minigraph-bg': !vibrationsNewModelSelected}">
                @if (vibrationsNewModelSelected()) {
                  <div>
                    <div class="charts">
                      @for (a of vibrationsNewModelSelected().channels; track a; let i = $index) {
                        <div class="chart">
                          @if (fourChannelCheck()) {
                            <canvas attr.id="canvas-{{i}}"  height="41vh"></canvas>
                          }
                          @if (!fourChannelCheck && i < 3) {
                            <canvas attr.id="canvas-{{i}}" height="54vh"></canvas>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </ng-template>
        </ngx-file-drop>
      </div>
    </div>
  </div>

  <!-- vibrations list -->
  <div class="wrapper-table-box">
    <div class="table-box">
      <table class="table">
        <thead>
          <tr>
            @for (propriete of proprietesAffichees; track propriete; let i = $index) {
              <th scope="col" (click)="sortByPropriete(propriete, i)">
                <div class="th-align">
                  {{propriete.libelleAffiche | translate}} @if (((i == 1)  || (i == 2) || (i == 3))) {
                  <i class="fas" [class.fa-sort-down]="arrowSort()[i] && i == activeSort()" [class.fa-sort-up]="!arrowSort()[i] || i != activeSort()"></i>
                }
              </div>
            </th>
          }
          <th scope="col" style="padding: 0;">
            <div id="tdPtControl">
              <ng-select name="selectPtControl"
                [disabled]="estModif()"
                id="selectPtControl"
                [items]="controlPoints"
                #selectPtControl="ngModel"
                bindLabel="name"
                [(ngModel)]="activeControlPointFilter"
                (change)="controlPointFilterChange()"
                required>
              </ng-select>
            </div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (vibration of vibrationsChart(); track vibration; let i = $index) {
          <tr  (click)="selectVibration(vibration,i)" >
            <td ><span [ngClass]="{'selected': i === this.indexSelected()}">{{i+1}}</span></td>
            <td title="{{vibration.header.fileName}}">{{vibration.header.fileName}}</td>
            <td title="{{vibration.header.equipementId}}">{{vibration.header.equipementId}}</td>
            <td title="{{vibration.header.timestamp | date : 'dd/MM/yyyy, HH:mm'}}">{{vibration.header.timestamp | date : 'dd/MM/yyyy, HH:mm'}}</td>
            <td title="{{vibration.header.note1}}">{{vibration.header.note1}}</td>
            <td title="{{vibration.header.recordLength}}">{{vibration.header.recordLength}}</td>
            <td>
              <div class="maximum">
                @for (data of vibration.channels; track data; let i = $index) {
                  <span>@if (i < 4) {
                    <span><b>C{{i+1}}: </b> {{findMaxAbsValue(data.minValue,data.maxValue) | number : '1.2-2'}}</span>
                  }</span>
                }
              </div>
            </td>
            <td>{{vibration.vecSomme  | number : '1.2-2' }}</td>
            <td>{{getControlPointName(vibration.header.controlPointId)}}</td>
            <td  [ngStyle]="estModif()?{'background-color':'#F9F9F9'}:{'background-color': 'inherit'}" (click)="deleteVibrationRemote(vibration.id)"><i class="fas fa-trash-alt"></i></td>
          </tr>
        }
        <tr></tr>
      </tbody>
    </table>
  </div>

  <div class="progress">
    <div class="progress-bar" role="progressbar" [ngStyle]="{'width': barValue()}" aria-valuenow="5" aria-valuemin="0" aria-valuemax="100">{{barValue()}}</div>
  </div>

</div>

</div>
